import { React, useState, useEffect, useRef } from "react";
import { Modal, DropdownButton, Dropdown } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import { Select } from "react-select-virtualized";
import helper from "../Helper/Helper";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import AxiosApi from "../Helper/axios.api";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import videocallicon from '../assets/images/videocall_icon.png';
import AnimationPreviews from "../Components/Frontend/AnimationPreviews";

export default function UpdateAnimation(props) {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [session, setSession] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [animation, setAnimation] = useState({ id: '', name: '', img: '', thumb: '', video: '' });
  const [initialAnimation, setInitialAnimation] = useState({ id: '', name: '', img: '', thumb: '', video: '' });
  const [hasChanges, setHasChanges] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [voiceSelectionChanged, setVoiceSelectionChanged] = useState(false);
  const animationPreviewsRef = useRef(null);

  const hideModal = () => {
    setAnimation({
      id: '',
      name: '',
      img: '',
      thumb: '',
      video: ''
    })
    setSession([])
    setIsEditing(false) // Reset editing state when modal closes
    setVoiceSelectionChanged(false)
    props.settempleteid('')
    props.setIsUpdate(!props.isUpdate);
    props.setModal(false)
  }
  const getanimation = (template_id) => {
    if (!template_id) return
    AxiosApi.withToken(auth.accessToken, "templates/" + template_id + "/details", "get", {})
      .then(async (res) => {
        if (res.status) {
          // Only update animation state if user is not currently editing
          // This prevents overwriting user input during auto-refresh
          if (!isEditing) {
            setAnimation(res.data);
            setInitialAnimation(res.data); // Store initial state for comparison
          }
          setSession(res.data.session);
        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  }
  useEffect(() => {
    if (props.templeteid && props.templeteid != '') {
      getanimation(props.templeteid);
    }

    return function () {
    };
  }, [props.templeteid, isUpdate]);
  useEffect(() => {
    const interval = setInterval(() => {
      // Only auto-refresh if user is not currently editing
      if (props.templeteid && props.templeteid != '' && !isEditing) {
        getanimation(props.templeteid);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [props.templeteid, isUpdate, isEditing]);

  // Check for changes when animation or voice settings change
  useEffect(() => {
    if (initialAnimation.id) {
      checkForChanges();
    }
  }, [animation, initialAnimation]);

  // Additional check when the ref becomes available
  useEffect(() => {
    if (animationPreviewsRef.current && initialAnimation.id) {
      // Small delay to ensure the child component is fully initialized
      setTimeout(checkForChanges, 100);
    }
  }, [animationPreviewsRef.current, initialAnimation.id]);

  // Reset changes when modal closes
  useEffect(() => {
    if (!props.modal) {
      setHasChanges(false);
      setIsEditing(false); // Reset editing state when modal closes
      setVoiceSelectionChanged(false);
    } else if (props.modal && initialAnimation.id) {
      // When modal opens, wait a bit for components to fully load, then check for changes
      const timeoutId = setTimeout(() => {
        checkForChanges();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [props.modal, initialAnimation.id]);
  const updateAnimation = async () => {
    let data = {};
    data.user_id = auth.userDeatils.user_id;
    data.template_id = animation.id;
    data.name = animation.name;
    data.voice_self_chosen = true;  // if you update we assume that you use the voice that was there

    // Always include current voice settings in the update
    if (animationPreviewsRef.current) {
      const currentVoiceSettings = animationPreviewsRef.current.getCurrentVoiceSettings();
      data.enable_morphing = currentVoiceSettings.enable_morphing;
      data.voice_model = currentVoiceSettings.voice_model;
    }

    await AxiosApi.withToken(auth.accessToken, "templates/edit", "post", data)
      .then((res) => {
        if (res.status) {
          // Update the AnimationPreviews component's initial settings to reflect the saved state
          if (animationPreviewsRef.current) {
            // Reset the initial settings to match current settings (no longer "changed")
            animationPreviewsRef.current.resetInitialVoiceSettings();
          }

          // Reset the initial animation state and clear changes flag
          setInitialAnimation({ ...animation });
          setHasChanges(false);
          setIsEditing(false); // Reset editing state after successful save
          setVoiceSelectionChanged(false);

          toast.success(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          hideModal();

        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  }
  const deleteAnimation = (id) => {
    props.setModal(false)
    confirmAlert({
      title: "Delete Animation",
      message: "Are you sure you want to delete this animation?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {

            let data = {};
            data.user_id = auth.userDeatils.user_id;
            data.template_id = id;

            await AxiosApi.withToken(auth.accessToken, "templates/delete", "post", data)
              .then((res) => {
                if (res.status) {
                  //await get_animation();
                  toast.success(res.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });

                  hideModal();

                } else {
                  toast.error(res.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                setLoading(false);
              })
              .catch((errors_res) => {
                setLoading(false);
              });

          },
        },
        {
          label: "No",
          onClick: async () => {
            props.setModal(true)
          }
        },
      ],
    });
  }
  const checkForChanges = () => {
    // Don't check for changes if the initial animation data isn't loaded yet
    if (!initialAnimation.id || !animation.id || initialAnimation.id !== animation.id) {
      setHasChanges(false);
      setVoiceSelectionChanged(false);
      return false;
    }

    // Check if name has changed
    const nameChanged = animation.name !== initialAnimation.name;

    // Check if voice settings have changed (selection)
    let voiceChanged = false;
    let voiceSelectionChangedLocal = false;

    if (animationPreviewsRef.current && typeof animationPreviewsRef.current.hasVoiceSettingsChanged === 'function') {
      try {
        voiceChanged = animationPreviewsRef.current.hasVoiceSettingsChanged();
        voiceSelectionChangedLocal = animationPreviewsRef.current.hasVoiceSelectionChanged?.() || false;

        // Update the state variables for use in the UI
        setVoiceSelectionChanged(voiceSelectionChangedLocal);

      } catch (error) {
        console.error("Error checking voice settings:", error);
        voiceChanged = false;
        setVoiceSelectionChanged(false);
      }
    } else {
      setVoiceSelectionChanged(false);
    }

    const hasAnyChanges = nameChanged || voiceChanged;
    setHasChanges(hasAnyChanges);
    return hasAnyChanges;
  };

  const onChangeValue = (e) => {
    let value = e.target.value;
    const newAnimation = {
      ...animation,
      [e.target.name]: value
    };
    setAnimation(newAnimation);
    setIsEditing(true); // Mark as editing when user changes input

    // Check for changes after updating animation
    setTimeout(checkForChanges, 0);
  };

  const handleVoiceSettingsChange = (voiceSettings) => {
    setIsEditing(true); // Mark as editing when voice settings change

    // Check for changes with a small delay to ensure the child component has updated
    setTimeout(() => {
      checkForChanges();
    }, 50); // Increased delay to ensure child component state is updated
  };
  function diffYMDHMS(date1, date2, fortime) {
    var string_data = "";
    let years = date1.diff(date2, 'year');
    date2.add(years, 'years');

    let months = date1.diff(date2, 'months');
    date2.add(months, 'months');

    let days = date1.diff(date2, 'days');
    date2.add(days, 'days');

    let hours = date1.diff(date2, 'hours');
    date2.add(hours, 'hours');

    let minutes = date1.diff(date2, 'minutes');
    date2.add(minutes, 'minutes');

    let seconds = date1.diff(date2, 'seconds');

    if (years > 0) {
      if (fortime) {
        return date1.local().format('MMM DD,YYYY h:mm A')
      } else {
        return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
      }

    }
    if (months > 0) {
      if (fortime) {
        return date1.local().format('MMM DD,YYYY h:mm A')
      } else {
        return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
      }
      // return date1.local().format('MMM DD,YYYY h:mm A') + '<p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i><p>';
    }

    if (days > 0) {
      if (days == 1) {
        if (fortime) {
          return "<b>Tomorrow</b> at <b>" + date1.local().format('h:mm A') + "</b>";
        } else {
          return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
        }
        // return "<b>Tomorrow</b> at <b>" + date1.local().format('h:mm A') + '</b> <p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
      } else {
        if (fortime) {
          return date1.local().format('MMM DD,YYYY h:mm A');
        } else {
          return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
        }
        // return date1.local().format('MMM DD,YYYY h:mm A') + '<p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i><p>';
      }

    }

    if (hours > 0) {
      string_data += " " + hours + "h";
    }
    if (minutes > 0) {
      string_data += " " + minutes + "m";
    }
    if (seconds > 0) {
      string_data += " " + seconds + "s";
    }
    if (fortime) {
      return "<b>Start</b> in <b>" + string_data + "</b>";
    } else {
      return '<p style="color: rgb(28, 93, 180); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
    }
    // return "<b>Start</b> in <b>" + string_data + '</b> <p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Update Schedule <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
  }
  const get_session_schedule = (session_data, asStringTime) => {

    var date2 = new Date();
    let current_time = moment(date2).format("yyyy-MM-DD HH:mm");
    let start_time = moment(session_data.time_start).format("yyyy-MM-DD HH:mm");
    let isFuture = moment(current_time).isBefore(start_time);  // true
    if (isFuture) {
      var now = moment(new Date());
      var end = moment(session_data.time_start);
      let diff = diffYMDHMS(end, now, asStringTime);
      return diff;
    } else {
      if (asStringTime) {
        return "<b>Session is in Progress..</b>";
      } else {
        return '<p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Open deeptherapy session <i class="fa fa-arrow-right" aria-hidden="true"></i></p>'
      }
      // return '<b>Session is in Progress..</b> <p style="color: rgb(0, 160, 254); cursor: pointer; font-weight:700;">Open deeptherapy session <i class="fa fa-arrow-right" aria-hidden="true"></i></p>';
    }

  }
  const isCurrentlyActive = (event_data) => {
    var new_data = new Date();
    let current_time = moment(new_data).format("yyyy-MM-DD HH:mm");
    let start_time = moment(event_data.time_start).format("yyyy-MM-DD HH:mm");
    let end_time = moment(event_data.time_end).format("yyyy-MM-DD HH:mm");
    return moment(current_time).isAfter(start_time) && moment(current_time).isBefore(end_time)
  }
  const show_modal = async (event_data) => {
    if (isCurrentlyActive(event_data)) {
      navigate("/reservation/" + event_data.id);
      // window.open("/reservation/" + event_data.id, event_data.id, 'width=700,height=400');
    }
  }
  const delete_reservations = async (reservation_id) => {
    setLoading(true);
    let data_params = {}
    data_params.user_id = auth.userDeatils.user_id;
    data_params.reservation_id = reservation_id;

    await AxiosApi.withToken(auth.accessToken, "reservations/delete", "post", data_params)
      .then(async (res) => {
        if (res.status) {
          setIsUpdate(!isUpdate)
          toast.success(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  }

  return (
    <Modal
      size="lg"
      show={props.modal}
      onHide={() => {
        hideModal();
      }}
      aria-labelledby="example-modal-sizes-title-lg"
      className="update-animation-modal advanced-modal"
      animation={true}
      centered
      style={{ zIndex: "999999" }}
    >
      <Modal.Header>
        <Modal.Title id="example-modal-sizes-title-lg">
          <div id={loading ? "pageLoader" : ""} />
          <h5 className="modal-title">Edit Animation</h5>
        </Modal.Title>
        <button
          type="button"
          className="modalOpenBtn btn bg-gradient-success pull-right"
          data-bs-toggle="modal"
          onClick={() => {
            hideModal();
          }}
        >
          <i
            style={{ fontSize: 20 }}
            className="fa fa-times"
            aria-hidden="true"
          ></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="profile-form-block mb-3">
          <div className="row align-items-end">
            <div className="col-md-5 col-8">
              <Label className="form-label mb-2 d-flex align-items-center" style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#495057'
              }}>
                <i className="fa fa-edit me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                Animation Name
                {animation.name !== initialAnimation.name && initialAnimation.id && animation.id && (
                  <span className="change-indicator ms-2" title="This field has been modified">
                    <i className="fa fa-circle" style={{ color: '#ffc107', fontSize: '8px' }}></i>
                  </span>
                )}
              </Label>
              <Input
                type="text"
                name="name"
                value={animation.name}
                onChange={(e) => onChangeValue(e)}
                placeholder="Enter animation name"
                style={{
                  borderRadius: '4px',
                  border: (animation.name !== initialAnimation.name && initialAnimation.id && animation.id)
                    ? '2px solid #ffc107'
                    : '1px solid #ced4da',
                  backgroundColor: '#ffffff',
                  padding: '8px 12px',
                  fontSize: '14px',
                  fontWeight: '400',
                  transition: 'all 0.2s ease-in-out',
                  boxShadow: (animation.name !== initialAnimation.name && initialAnimation.id && animation.id)
                    ? '0 0 0 0.1rem rgba(255, 193, 7, 0.2)'
                    : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                }}
                onFocus={(e) => {
                  if (!e.target.style.borderColor.includes('#ffc107')) {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.borderColor = '#007bff';
                    e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                  }
                }}
                onBlur={(e) => {
                  if (!e.target.style.borderColor.includes('#ffc107')) {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.borderColor = '#ced4da';
                    e.target.style.boxShadow = 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                  }
                }}
              />
            </div>
            <div className="col-md-7 col-4 text-end">
              <button
                type="button"
                className="btn btn-warning text-white me-2"
                title={"Delete"}
                onClick={(e) => deleteAnimation(animation.id)}
              >
                Delete
              </button>
              <button
                type="button"
                className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
                onClick={(e) => updateAnimation()}
                title={hasChanges ? "Save Animation" : "No changes to save"}
                disabled={!hasChanges}
                style={{
                  position: 'relative',
                  boxShadow: hasChanges ? '0 0 0 0.2rem rgba(255, 193, 7, 0.5)' : undefined,
                  borderColor: hasChanges ? '#ffc107' : undefined
                }}
              >
                {hasChanges && (
                  <span className="change-indicator-pulse" style={{
                    position: 'absolute',
                    top: '-3px',
                    right: '-3px',
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#ffc107',
                    borderRadius: '50%',
                    animation: 'pulse-yellow 1.5s infinite'
                  }}></span>
                )}
                Save Changes
              </button>
            </div>
          </div>

          {/* Change summary - always present to prevent layout shift */}
          <div
            className="mt-3 rounded-3 overflow-hidden"
            style={{
              transition: 'all 0.3s ease-in-out',
              maxHeight: hasChanges ? '200px' : '0px',
              opacity: hasChanges ? 1 : 0,
              marginBottom: hasChanges ? '0' : '-12px' // Compensate for margin when collapsed
            }}
          >
            <div className="p-3 bg-light border-start border-warning border-4">
              <div className="d-flex align-items-center mb-2">
                <i className="fa fa-edit me-2" style={{ color: '#ff6b35', fontSize: '16px' }}></i>
                <span className="fw-semibold text-dark">Pending Changes</span>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {(animation.name !== initialAnimation.name && initialAnimation.id && animation.id) && (
                  <span className="badge rounded-pill px-3 py-2 d-flex align-items-center" style={{
                    backgroundColor: '#e3f2fd',
                    color: '#1976d2',
                    fontSize: '12px',
                    fontWeight: '500',
                    border: '1px solid #bbdefb'
                  }}>
                    <i className="fa fa-font me-1" style={{ fontSize: '10px' }}></i>
                    Animation Name
                  </span>
                )}
                {voiceSelectionChanged && (
                  <span className="badge rounded-pill px-3 py-2 d-flex align-items-center" style={{
                    backgroundColor: '#e8f5e8',
                    color: '#2e7d32',
                    fontSize: '12px',
                    fontWeight: '500',
                    border: '1px solid #c8e6c9'
                  }}>
                    <i className="fa fa-microphone me-1" style={{ fontSize: '10px' }}></i>
                    Voice Selection
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <AnimationPreviews
          ref={animationPreviewsRef}
          templateId={props.templeteid}
          thumb={animation.thumb}
          createPreviews={props.createPreviews}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          onVoiceSettingsChange={handleVoiceSettingsChange}
        />
      </Modal.Body>

      {/* Custom CSS for change indicators */}
      <style jsx='true'>{`
        @keyframes pulse-yellow {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
          }
          70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
          }
          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
          }
        }

        .change-indicator {
          display: inline-block;
          animation: pulse-yellow 2s infinite;
        }

        .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>

    </Modal>
  );
}
